import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { CheckResetPasswordTokenMutationVariables, CheckResetPasswordTokenMutation } from '@/gql/graphql';

export const checkResetPasswordToken = async ({
  token,
}: CheckResetPasswordTokenMutationVariables): Promise<CheckResetPasswordTokenMutation['checkResetPasswordToken']> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CheckResetPasswordToken($token: String!) {
        checkResetPasswordToken(token: $token) {
          expired
          hasEmail
          hasPassword
        }
      }
    `),
    variables: {
      token,
    },
  });

  return response?.data?.checkResetPasswordToken ?? null;
};
